
import { useState } from "react";
import { Order } from "@/store/orderStore";

interface UseCartDialogProps {
  activeOrder: Order | null;
}

export function useCartDialog({ activeOrder }: UseCartDialogProps) {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  
  // Function to handle the cart icon click
  const handleCartIconClick = () => {
    if (activeOrder && !isCartOpen) {
      setIsConfirmDialogOpen(true);
    } else {
      setIsCartOpen(true);
    }
  };

  // Function to continue with opening cart after confirmation
  const handleConfirmOpenCart = () => {
    setIsConfirmDialogOpen(false);
    setIsCartOpen(true);
  };
  
  return {
    isCartOpen,
    setIsCartOpen,
    isConfirmDialogOpen,
    setIsConfirmDialogOpen,
    handleCartIconClick,
    handleConfirmOpenCart
  };
}
